import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import LoadingSpinner from "../../../../../features/shared/components/Loaders"
import { Exam } from "../../../../../utils/api-objects/Exam"
import { getMealPlanPdfs } from "../../../../../utils/apis/plan-service"
import { useAuthStore } from "../../../../../utils/stores/useAuthStore"
import BackButton from "../../../components/BackButton"
import { PdfCard, PdfType } from "../../../components/PdfCard"

const MealPlanSupportPdfsPage = () => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId
    const navigate = useNavigate()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search);
    const mealPlanId = searchParams.get("meal_plan_id");

    const [isGeneralLoading, setIsGeneralLoading] = useState(true);

    const [pdfs, setPdfs] = useState<Exam[]>()

    const fetchPdfs = async () => {
        if (!userId || !idToken) return;
        const supportFolder = `${mealPlanId}/support_materials`;

        try {
            const supportUrls = await getMealPlanPdfs(userId, idToken, supportFolder)
            setPdfs(supportUrls)
        } catch (error) {
            console.error(error);
        } finally {
            setIsGeneralLoading(false);
        }
    };

    useEffect(() => {
        fetchPdfs();
    }, []);

    if (isGeneralLoading || !pdfs) {
        return (
            <LoadingSpinner />
        );
    }

    return (
        <div className="w-full h-full flex flex-col space-y-[20px]">
            <div className="mt-[10px] space-y-[10px]">
                <BackButton
                    text="Torna a Meal Plan"
                    onClick={() => navigate(`/meal-plan/pdfs?meal_plan_id=${mealPlanId}`)}
                />
                <div className="font-bold text-[25px] leading-[33px]">
                    🗂️ A supporto del Meal Plan
                </div>
            </div>
            <div className="w-full pb-[20px]">
                <div className="flex flex-col md:flex-row md:flex-wrap gap-4">
                    {pdfs.map((pdf, index) => (
                        <PdfCard key={index} exam={pdf} pdfType={PdfType.Uploads} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default MealPlanSupportPdfsPage
